/**
 * Operator guidance shown on coverage term-mismatch findings (committed on one
 * term, billed on another). Shared by the customer drill-down and the Variances
 * tab so the wording stays consistent.
 */
export const TERM_MISMATCH_TOOLTIP =
  'When attempting to align terms, plan to cancel the Synnex subscription on the ' +
  'day it renews and create a new subscription for the correct term using the ' +
  'co-term date (Synnex will offer the last day of the previous month).';
